'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setStatic = require('./setStatic');

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;


//////////////////
// WEBPACK FOOTER
// ./~/recompose/setDisplayName.js
// module id = 142
// module chunks = 70144966829960 114276838955818